import React from 'react';
import { StyleSheet, View } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

import { useSvgId } from '../../../utils/hooks/useSvgId';

type Props = {
	/** [offset, colour] stops, offsets as '0'..'1'. */
	stops: Array<[string, string]>;
	/** Corner radius, to match the view it fills. */
	radius?: number;
	/** 'vertical' (top to bottom, the default) or 'horizontal'. */
	direction?: 'vertical' | 'horizontal';
};

/**
 * An absolutely-filling linear gradient for a plate or a button. React Native has no gradient
 * background, so the redesign paints one with an SVG laid under the content; put it first in the
 * view and give the view `overflow: 'hidden'` or a matching `radius`.
 */
export const GradientFill = ({ stops, radius = 0, direction = 'vertical' }: Props) => {
	const id = useSvgId('gradientFill');
	const horizontal = direction === 'horizontal';

	return (
		<View
			pointerEvents='none'
			style={[StyleSheet.absoluteFill, { borderRadius: radius, overflow: 'hidden' }]}
		>
			<Svg width='100%' height='100%'>
				<Defs>
					<LinearGradient
						id={id}
						x1='0'
						y1='0'
						x2={horizontal ? '1' : '0'}
						y2={horizontal ? '0' : '1'}
					>
						{stops.map(([offset, color]) => (
							<Stop key={offset} offset={offset} stopColor={color} />
						))}
					</LinearGradient>
				</Defs>
				<Rect width='100%' height='100%' rx={radius} ry={radius} fill={`url(#${id})`} />
			</Svg>
		</View>
	);
};

export default GradientFill;
